import { defineGameCard, onDeath } from '../authoring/index.js';
import { deathController } from './furniture_helpers.js';
export const JunkChestCard = defineGameCard({
    id: 'junk_chest',
    gameplay: { type: 'STRUCTURE', cost: 1, baseStats: { attack: 0, health: 3 } },
    presentation: {
        name: 'Сундук с барахлом',
        description: 'Сразу после гибели возьмите 1 карту.',
        glyph: {
            colors: ['#10213A', '#C08249', '#944F29', '#6D3E29', '#854525'],
            rows: [
                '..1111111111111111..',
                '.122222222222222221.',
                '.134444444444444431.',
                '.154111111111111451.',
                '.154111111111111451.',
                '..1411541111111141..',
                '..1112223111111141..',
                '..1112223311441141..',
                '..112222135111141...',
                '..1122215351145441..',
                '.121441135411141121.',
                '.121115111111111121.',
                '.122222223332222221.',
                '.151111113311111151.',
                '.155555513515555551.',
                '.151151111111155151.',
                '.155555551145555551.',
                '.151111111111111151.',
                '.155555555555555551.',
                '..1111111111111111..',
            ],
        },
    },
    role: 'playable',
    abilities: [
        onDeath((ctx, event) => {
            const controllerId = deathController(ctx, event);
            if (controllerId !== undefined)
                ctx.ops.drawCard(controllerId, 1);
        }),
    ],
    ui: { mechanics: ['death'] },
});
//# sourceMappingURL=junk_chest.js.map